$(function() {
    // Article scroll
    if ($("article.blogArticle").length > 0) {
        $(window).scroll(function() {
            //Content scroll effect
            var defaultTop = -120;
            var max = -400;
            var position = $(window).scrollTop();
            var wrapper = $("article.blogArticle > div.wrapper");

            if ((defaultTop - (position/2)) >= max) {
                if (!wrapper.hasClass('noCoverImage')) {
                    wrapper.css('margin-top', (defaultTop-(position/2)) + 'px');
                }
            }

            //Toolbar fix
            var wrapperTop = $("article.blogArticle > div.wrapper").offset().top;
            if (wrapperTop <= position) {
                $("article.blogArticle > div.wrapper").addClass('fixedToolbar');
                $("article.blogArticle div.toolbar").addClass('fixed');
            } else {
                $("article.blogArticle > div.wrapper").removeClass('fixedToolbar');
                $("article.blogArticle div.toolbar").removeClass('fixed');
            }
        });
    }

    //Image info
    $("article.blogArticle div.image > div.description > i.fa").click(function() {
        $(this).parents("div.description").children("div").stop().fadeToggle(300);
    });

    //Glossary
    $(document).on('click', 'a.letter', function(event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $( $.attr(this, 'href') ).offset().top - 90
        }, 500);
    });
    $(document).on('keyup', 'div.glossarySearch > input[type=text]', function() {
        var word = $(this).val();

        if (word.length > 0) {
            var firstLetter = word[0].toUpperCase();

            if ($("#words" + firstLetter).length > 0) {
                $('html, body').stop().animate({
                    scrollTop: $("#words" + firstLetter).offset().top - 90
                }, 500);
            }
        }

        //Mark words
        $("div.articleCard h3 > a > span.title > span.marked").each(function() {
            $(this).parent("span.title").html($(this).parent("span.title").text());
        });
        if (word.length > 0) {
            $("div.articleCard h3 > a > span.title").each(function() {
                var title = $(this).text();
                var firstPart = title.substr(0, word.length);
                if (firstPart.toUpperCase() === word.toUpperCase()) {
                    var secondPart = title.substr(word.length);

                    $(this).html('<span class="marked">' + firstPart + '</span>' + secondPart);
                }
            });
        }
    });
    if ($("div.glossary").length > 0) {
        var glossarySearch = $("div.glossary div.glossarySearch");
        var glossarySearchTop = glossarySearch.offset().top + glossarySearch.height();

        //Focus
        glossarySearch.find("input[type=text]").focus();

        $(window).scroll(function () {
            if ($(window).scrollTop() > glossarySearchTop) {
                glossarySearch.addClass("fixed");
                $("div.glossary div.teaser").css('padding-bottom', '127px');
            } else {
                glossarySearch.removeClass("fixed");
                $("div.glossary div.teaser").css('padding-bottom', '45px');
            }
        });
    }

    //Recipe
    if ($("div.recipe ol.steps > li.active").length === 0) {
        $("div.recipe ol.steps > li").click(function() {
            var time = parseInt($(this).data("time"), 10);
            window.recipePlayer.seekTo(time);
        });
    }
});

//Video
window.recipePlayer;
window.recipePlayerInterval = null;
if ($("article.blogArticle div.recipe").length > 0) {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

window.onYouTubeIframeAPIReady = function() {
    var videoID = $("article.blogArticle div.recipe").data("youtube-code");

    window.recipePlayer = new YT.Player('recipePlayer', {
        height: '360',
        width: '640',
        videoId: videoID,
        events: {
            'onReady': onPlayerReady
        }
    });

    window.recipePlayerInterval = setInterval(function() {
        var time = Math.floor(window.recipePlayer.getCurrentTime());

        $("div.recipe ol.steps > li").each(function() {
            var seconds = parseInt($(this).data("time"), 10);
            if (time >= seconds) {
                $("div.recipe ol.steps > li").removeClass("active");
                $(this).addClass("active");
            }
        });

        if ($("div.recipe ol.steps > li.active").length === 0) {
            $("div.recipe ol.steps > li").eq(0).addClass("active");
        }
    }, 500);
}

window.onPlayerReady = function(event) {
    event.target.playVideo();
}
